import * as types from './types';

const initialState = {
  isRetake: false,
  retakeArr: [],
  retakeFrom: '',
  sessionID: '',
  classNameCustom: 'retake',
  retakeStatus: 'NONE',
};

const retakeReducer = (state = initialState, action) => {
  const type = action.type;
  switch (type) {
    case types.SHOW_RETAKE_UI: {
      const payload = action.data;
      return { ...payload };
    }
    case types.HIDE_RETAKE_UI: {
      const hideData = action.hideData;
      return { ...hideData };
    }
    case types.CHANGE_STATUS_RETAKE: {
      const id = action.id;
      const stateTemp = { ...state };
      const arrTemp =
        !!stateTemp && !!stateTemp.retakeArr && stateTemp.retakeArr;
      if (!!arrTemp) {
        const found = arrTemp.find((item) => item.photoCodeUpload === id);
        if (found) {
          found.newStatus = 'DONE';
        }
      }
      return { ...state, retakeArr: arrTemp };
    }

    default:
      return state;
  }
};
export default retakeReducer;
